import type { Options } from "@hey-api/client-fetch";
import { client } from "@/app";
import * as api from "@/app/api";
import { useLoginStore } from "@/app/stores/login.store";

export class LoginError extends Error {
    private code: number;

    constructor(reason: string, code: number) {
        super(reason);

        this.code = code;
    }
}

export class LoginController {
    private static is_set = false;

    static init() {
        const token = this.getToken();
        if (token) {
            this.setToken(token);
        }
    }

    static async login(
        username: string,
        password: string,
        store: boolean = true,
    ) {
        const response = await api.loginAccessTokenApiV1LoginTokenPost({
            body: {
                grant_type: "password",
                username: username,
                password: password,
            },
        });

        if (response.error) {
            throw new LoginError(
                response.error as string,
                response.response.status,
            );
        }

        this.setToken(response.data);
        if (store) localStorage.setItem("login", JSON.stringify(response.data));
    }

    static logout() {
        localStorage.removeItem("login");
        this.setToken(null);
    }

    private static setToken(token: api.Token | null) {
        const store = useLoginStore();

        const _auth = (req: Request, options: Options) => {
            req.headers.append(
                "Authorization",
                `${token.token_type} ${token.access_token}`,
            );
            return req;
        };

        if (store.token && token) {
            client.interceptors.request.eject(_auth);
        } else if (!token) {
            client.interceptors.request.eject(_auth);
        }

        store.token = token;

        if (token) {
            client.interceptors.request.use(_auth);
        }
    }

    static getToken() {
        const login = localStorage.getItem("login");
        if (login !== null) return JSON.parse(login) as api.Token;
        return null;
    }
}
